/**
 * 表单控件需要的属性
 */
export const formProps = {
  modelValue: Object, //完整的model
  formColCount: {
    // 表单的列数
    type: Number,
    default: 1
  },
  labelWidth: { type: String, default: '120px' },
  labelPosition: { type: String, default: 'right' },
  isEditor: { type: Boolean, default: false },
  isDisabled: { type: Boolean, default: false },
  /*操作类型*/
  opType: {
    type: Number,
    default: 0
  },
  reset: {
    type: Function,
    default: () => {}
  },
  // 头部样式my-header、my-title、my-header-none
  headerClass: { type: String, default: 'my-header-none' },
  meta: {
    type: [Object, Array],
    default: null
  }
}
/**
 * 基础控件的共用属性
 */
export const baseProps = {
  item: {
    type: Object,
    default: null
  },
  isEditor: {
    type: Boolean,
    default: false
  },
  isDisabled: {
    type: Boolean,
    default: false
  },
  delay: {
    type: Number,
    default: 1
  }
}
